<div tabindex="0">
  <app-preview-data-wrapper
    [label]="'Adres zagraniczny'"
    [data]="address()?.czyAdresZagraniczny"
    [dataType]="PreviewDataType.CHECKBOX"
  ></app-preview-data-wrapper>
</div>
<br />
@if (!address()?.czyAdresZagraniczny!) {
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Nazwa państwa'"
        [data]="'Polska'"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Gmina/Dzielnica'"
        [data]="address()?.adres?.gminaDzielnica?.nazwa"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Miejscowość'"
        [data]="address()?.adres?.miejscowosc?.nazwa"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Ulica'"
        [data]="address()?.adres?.ulica?.nazwa"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer domu'"
        [data]="address()?.adres?.nrDomu"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer lokalu'"
        [data]="address()?.adres?.nrLokalu"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Kod pocztowy'"
        [data]="address()?.adres?.kodPocztowy"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Poczta'"
        [data]="address()?.adres?.poczta"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
  </div>
} @else {
  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Nazwa państwa'"
        [data]="address()?.adresZagraniczny?.panstwo?.nazwa"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Gmina/Dzielnica'"
        [data]="address()?.adresZagraniczny?.gminaDzielnica"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Miejscowość'"
        [data]="address()?.adresZagraniczny?.miejscowosc"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Ulica'"
        [data]="address()?.adresZagraniczny?.ulica"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer domu'"
        [data]="address()?.adresZagraniczny?.nrDomu"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer lokalu'"
        [data]="address()?.adresZagraniczny?.nrLokalu"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Zagraniczny kod pocztowy'"
        [data]="address()?.adresZagraniczny?.kodPocztowyZagraniczny"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
  </div>
}
